import { useParams } from '@tanstack/react-router'

import { UserResponse } from 'api/endpoints/openapi-generated.schemas'
import { ARTIFIC_COMPANY_SLUGS } from 'constants/artific'
import { InterviewRoute } from 'constants/router'
import { InterviewStageEnum } from 'consts/company-alias.consts'
import { Interview } from 'features/interview'
import { useEffect } from 'react'
import { captureError } from 'utils/sentry'
import { QueryParams, Route } from 'routes/$companyAlias/$positionAlias'
import Cookies from 'js-cookie'

export const MainPage = ({
  // TODO: need to be fixed
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  userData: preloadUser
}: {
  userData?: UserResponse
}) => {
  const { companyAlias, positionAlias } = useParams({
    strict: false
  }) as {
    companyAlias: string
    positionAlias: string
  }
  const { reset } = Route.useSearch() as QueryParams

  useEffect(() => {
    const isOldInterviewPage = ARTIFIC_COMPANY_SLUGS.includes(companyAlias)
    if (isOldInterviewPage) {
      captureError('Detected old interview page usage', {
        companyAlias,
        positionAlias
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyAlias])

  // clear all local storage items and cookies
  if (reset) {
    Cookies.remove('app.ap')

    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key: string | null = localStorage.key(i)

      if (key) {
        localStorage.removeItem(key)
      }
    }

    window.open(
      `${window.location.origin}${window.location.pathname}?stage=${InterviewStageEnum.Welcome}`,
      '_self'
    )
    return null
  }

  const isInterviewPage = companyAlias === InterviewRoute

  return (
    <div style={{ marginLeft: 0, marginRight: 0 }}>
      {isInterviewPage && <Interview />}
    </div>
  )
}
